import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-newrequest',
  templateUrl: './newrequest.component.html',
  styleUrls: ['./newrequest.component.scss']
})
export class NewrequestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }



}
